import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

const TemplateListHeader = ({}) => (
  <Container>
    <Grid container>
      <Grid item xs={7}>
        <StyledTypography weight={600} variant="body2" color="textSecondary">
          Name
        </StyledTypography>
      </Grid>
      <Grid item xs={3}>
        <StyledTypography weight={600} variant="body2" color="textSecondary">
          Created By
        </StyledTypography>
      </Grid>
      <Grid item xs={2}>
        <StyledTypography weight={600} variant="body2" color="textSecondary">
          Questions
        </StyledTypography>
      </Grid>
    </Grid>
  </Container>
);

const Container = styled.div`
  padding: 0 1.5rem;
`;

export default TemplateListHeader;
